<div class="card" [ngClass]="{ 'permit-card': templateForPermitForm }">
  <div class="card-body">
    <!-- Added by amisha on 24/12/2025 -->
    @if (!templateForPermitForm) {
    <h6 class="mt-1" *ngIf="logEmail.delivered">
      <span class="text-success"><strong>Delivered</strong></span> on
      {{ logEmail.sentAtString }}
    </h6>

    <h6 class="mt-1" *ngIf="!logEmail.delivered && logEmail.sentAtString">
      <span class="text-warning"><strong>Not Delivered</strong></span> -
      Attempted delivery {{ logEmail.sentAtString }}
    </h6>

    <h6
      class="mt-1"
      *ngIf="
        !logEmail.delivered &&
        logEmail.sendOnString &&
        !logEmail.sentAtString &&
        !logEmail.canceledOnString
      "
    >
      <span class="text-success"><strong>Scheduled</strong></span> for
      {{ logEmail.sendOnString }}
      (<strong
        >Any application data entities are evaluated when the email is
        sent</strong
      >)
    </h6>

    <h6 class="mt-1" *ngIf="logEmail.canceledOnString">
      <span class="text-warning"><strong>Canceled</strong></span> on
      {{ logEmail.canceledOnString }}
    </h6>

    } @else {

    <div class="permit-status" *ngIf="logEmail.delivered">
      <wm-common-text
        class="status-label status-success"
        [data]="{ text: 'Delivered' }"
      ></wm-common-text>
      <wm-common-text
        class="status-date"
        [data]="{ text: ' on ' + logEmail.sentAtString }"
      ></wm-common-text>
    </div>

    <div
      class="permit-status"
      *ngIf="!logEmail.delivered && logEmail.sentAtString"
    >
      <wm-common-text
        class="status-label status-warning"
        [data]="{ text: 'Not Delivered' }"
      ></wm-common-text>
      <wm-common-text
        class="status-date"
        [data]="{ text: ' - Attempted delivery ' + logEmail.sentAtString }"
      ></wm-common-text>
    </div>

    <div
      class="permit-status"
      *ngIf="
        !logEmail.delivered &&
        logEmail.sendOnString &&
        !logEmail.sentAtString &&
        !logEmail.canceledOnString
      "
    >
      <wm-common-text
        class="status-label status-success"
        [data]="{ text: 'Scheduled' }"
      ></wm-common-text>
      <wm-common-text
        class="status-date"
        [data]="{
          text:
            ' for ' +
            logEmail.sendOnString +
            ' (Any application data entities are evaluated when the email is sent)'
        }"
      ></wm-common-text>
    </div>

    <div class="permit-status" *ngIf="logEmail.canceledOnString">
      <wm-common-text
        class="status-label status-warning"
        [data]="{ text: 'Canceled' }"
      ></wm-common-text>
      <wm-common-text
        class="status-date"
        [data]="{ text: ' on ' + logEmail.canceledOnString }"
      ></wm-common-text>
    </div>

    }

    <div class="mt-3" *ngIf="logEmail.errorStatus">
      <span class="text-danger">{{ logEmail.errorStatus }}</span>
    </div>
    @if (!templateForPermitForm) {

    <div
      class="mt-3"
      *ngIf="
        showEmailApplicantValue ||
        (logEmail.roleNames && logEmail.roleNames.length > 0)
      "
    >
      <h6><strong>Options</strong></h6>
    </div>

    } @else {

    <div
      class="mt-3"
      *ngIf="
        showEmailApplicantValue ||
        (logEmail.roleNames && logEmail.roleNames.length > 0)
      "
    >
      <wm-common-text
        class="section-header"
        [data]="{ text: 'Options' }"
      ></wm-common-text>
    </div>

    } @if (!templateForPermitForm) {
    <ul style="list-style-type:none;">
      <li *ngIf="showEmailApplicantValue">
        Send to the applicant?
        {{ emailApplicantValue ? 'Yes' : 'No' }}
      </li>

      <li *ngIf="logEmail.roleNames && logEmail.roleNames.length > 0">
        Send to members of the following roles:
        <ul class="list-group bmd-list-group-sm">
          <li
            class="list-group-item"
            *ngFor="let roleName of logEmail.roleNames"
          >
            {{ roleName }}
          </li>
        </ul>
      </li>
    </ul>

    } @else {
    <ul style="list-style-type:none;" class="permit-options-list">
      <li *ngIf="showEmailApplicantValue">
        <wm-common-text
          [data]="{
            text:
              'Send to the applicant? ' + (emailApplicantValue ? 'Yes' : 'No')
          }"
        ></wm-common-text>
      </li>

      <li *ngIf="logEmail.roleNames && logEmail.roleNames.length > 0">
        <wm-common-text
          [data]="{ text: 'Send to members of the following roles:' }"
        ></wm-common-text>

        <ul class="list-group bmd-list-group-sm">
          <li
            class="list-group-item"
            *ngFor="let roleName of logEmail.roleNames"
          >
            <wm-common-text [data]="{ text: roleName }"></wm-common-text>
          </li>
        </ul>
      </li>
    </ul>

    } @if (!templateForPermitForm) {
    <div class="mt-3">
      <h6><strong>Recipients</strong></h6>

      <p
        class="text-warning"
        *ngIf="
          logEmail.toRecipients.length < 1 &&
          logEmail.ccRecipients.length < 1 &&
          logEmail.bccRecipients.length < 1 &&
          logEmail.roleNames.length < 1 &&
          showEmailApplicantValue &&
          !emailApplicantValue
        "
      >
        There were no recipients...
      </p>

      <div
        *ngIf="
          (logEmail.toRecipients && logEmail.toRecipients.length > 0) ||
          (showEmailApplicantValue && emailApplicantValue)
        "
      >
        <h6>To:</h6>
        <ul class="list-group bmd-list-group-sm">
          <li class="list-group-item" *ngFor="let to of logEmail.toRecipients">
            {{ to }}
          </li>
        </ul>
      </div>

      <div *ngIf="logEmail.ccRecipients && logEmail.ccRecipients.length > 0">
        <h6>CC:</h6>
        <ul class="list-group bmd-list-group-sm">
          <li class="list-group-item" *ngFor="let cc of logEmail.ccRecipients">
            {{ cc }}
          </li>
        </ul>
      </div>

      <div *ngIf="logEmail.bccRecipients && logEmail.bccRecipients.length > 0">
        <h6>BCC:</h6>
        <ul class="list-group bmd-list-group-sm">
          <li
            class="list-group-item"
            *ngFor="let bcc of logEmail.bccRecipients"
          >
            {{ bcc }}
          </li>
        </ul>
      </div>
    </div>

    } @else {
    <div class="mt-3">
      <wm-common-text
        class="section-header"
        [data]="{ text: 'Recipients' }"
      ></wm-common-text>

      <wm-common-text
        class="text-warning"
        *ngIf="
          logEmail.toRecipients.length < 1 &&
          logEmail.ccRecipients.length < 1 &&
          logEmail.bccRecipients.length < 1 &&
          logEmail.roleNames.length < 1 &&
          showEmailApplicantValue &&
          !emailApplicantValue
        "
        [data]="{ text: 'There were no recipients...' }"
      ></wm-common-text>

      <div
        *ngIf="
          (logEmail.toRecipients && logEmail.toRecipients.length > 0) ||
          (showEmailApplicantValue && emailApplicantValue)
        "
      >
        <wm-common-text [data]="{ text: 'To:' }"></wm-common-text>
        <ul class="list-group bmd-list-group-sm">
          <li class="list-group-item" *ngFor="let to of logEmail.toRecipients">
            <wm-common-text [data]="{ text: to }"></wm-common-text>
          </li>
        </ul>
      </div>

      <div *ngIf="logEmail.ccRecipients && logEmail.ccRecipients.length > 0">
        <wm-common-text [data]="{ text: 'CC:' }"></wm-common-text>
        <ul class="list-group bmd-list-group-sm">
          <li class="list-group-item" *ngFor="let cc of logEmail.ccRecipients">
            <wm-common-text [data]="{ text: cc }"></wm-common-text>
          </li>
        </ul>
      </div>

      <div *ngIf="logEmail.bccRecipients && logEmail.bccRecipients.length > 0">
        <wm-common-text [data]="{ text: 'BCC:' }"></wm-common-text>
        <ul class="list-group bmd-list-group-sm">
          <li
            class="list-group-item"
            *ngFor="let bcc of logEmail.bccRecipients"
          >
            <wm-common-text [data]="{ text: bcc }"></wm-common-text>
          </li>
        </ul>
      </div>
    </div>

    } @if (!templateForPermitForm) {
    <div
      class="mt-3"
      *ngIf="logEmail.attachments && logEmail.attachments.length > 0"
    >
      <h6><strong>Attachments</strong></h6>
      <ul class="list-group bmd-list-group-sm">
        <li
          class="list-group-item"
          *ngFor="let attachment of logEmail.attachments"
        >
          <a href="{{ attachment.path }}" target="blank">
            {{ attachment.name }}
          </a>
        </li>
      </ul>
    </div>

    } @else {
    <div
      class="mt-3"
      *ngIf="logEmail.attachments && logEmail.attachments.length > 0"
    >
      <wm-common-text
        class="section-header"
        [data]="{ text: 'Attachments' }"
      ></wm-common-text>

      <ul class="list-group bmd-list-group-sm">
        <li
          class="list-group-item"
          *ngFor="let attachment of logEmail.attachments"
        >
          <a href="{{ attachment.path }}" target="blank">
            <wm-common-text [data]="{ text: attachment.name }"></wm-common-text>
          </a>
        </li>
      </ul>
    </div>

    }

    <hr />
    @if (!templateForPermitForm) {
    <h6><strong>Subject: </strong> {{ logEmail.subject }}</h6>

    <div class="p-2" [innerHTML]="logEmail.body"></div>

    } @else {
    <wm-common-text
      class="section-header"
      [data]="{ text: 'Subject:' }"
    ></wm-common-text>

    <wm-common-text [data]="{ text: logEmail.subject }"></wm-common-text>

    <div class="p-2" [ngClass]="{ 'email-body': templateForPermitForm }" [innerHTML]="logEmail.body"></div>

    }
  </div>
</div>

<br />
